module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Though the blindfold prevented Rachel from seeing where they were going, the drive had taken less than twenty minutes. She knew they were still in the vicinity of Shadow Mountain Lake, still in Grand County. If she could figure out her location, she might somehow get a message to Jim, and he could coordinate her rescue through the sheriff’s department.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The van door opened, and Cole took her arm, guiding her as she stumbled up a wood staircase. Looking down under the edge of the blindfold, she saw it had been partially cleared of snow. The porch was several paces across; this had to be a large house or a lodge.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She heard the front door open and felt a gush of warmth from inside. A man ordered, “Get the hell in here. Fast.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s the problem?” Cole asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s Penny. She’s got a gun.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel stifled a hysterical urge to laugh. Penny had to be every man’s worst nightmare: a woman in labor with a firearm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Inside the house, Cole held her arm and marched her across the room. He tapped on a door. “Penny? I’m coming in. I brought a midwife to help you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Rachel stepped into the bedroom, she was struck by a miasma of floral perfume, antiseptic and sweat.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cole wasted no time in removing the blindfold and the handcuffs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From the bed, Penny stared at her with hollow eyes smeared with makeup. Her skinny arm trembled with the effort of holding a revolver that looked as big as a canon. A flimsy nightgown covered her swollen breasts and ripe belly, but her pale legs were bare. The dressing on her thigh wound was bloodstained.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t want drugs,” Penny rasped. “This baby is going to be born healthy. Hear me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel nodded. “Can I come closer?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why?” Her eyes narrowed suspiciously. “What are you going to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m going to help you have this baby.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“First things first,” Cole said. “Give me the gun.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No way.” Penny’s breathing became more rapid. Her lips pulled back as she gritted her teeth. Her eyes squeezed shut.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even wearing the ski mask, Cole looked nervous. “What’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A contraction,” Rachel said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A sob choked through Penny’s lips. Still clutching the gun, she threw her head back, fighting the pain with every muscle in her body. She stayed that way for several seconds. Instead of a scream, she exhaled a gasp. “Damn it. This is going to get worse, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here’s the thing about natural childbirth,” Rachel said as she moved closer to the bed. “It’s important for you to be comfortable and relaxed. My name is Rachel, by the way. How far apart are the contractions?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not sure. Eight or ten minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“First baby?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Experience told Rachel that Penny wasn’t anywhere ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("near the final stages of labor. They probably had several more hours to look forward to. “Can I take a look at that wound on your leg?”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Whatever.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel sat on the bed beside her and gently pulled the bandage back. In her work as an EMT, she’d dealt with gunshot wounds before. She could tell that the bullet had entered the back of Penny’s leg—probably as she was running away—and exited through the front. The torn flesh was clumsily sutured and caked with dried blood. “It doesn’t appear to be infected. Can you walk on it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Defiantly, Penny said, “Damn right I can.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d like you to walk into the bathroom and take a bath. Treat yourself to a nice, long soak.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t need pampering.” Her raccoon eyes were fierce. “I can take the pain.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel looked away from the gun barrel that was only inches from her cheek. She didn’t like Penny, didn’t like that she was a criminal on the run and definitely didn’t like her attitude. But this woman was her patient now, and Rachel’s goal was a successful delivery.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sure you’re tough as nails, Penny.” Rachel stood and stepped away from the bed. “But this isn’t about you. It’s about your baby. You need to conserve your strength so you’re ready to push when the time comes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cole approached the opposite side of the bed. “Listen to her, Penny.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fine. I’ll take a bath.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel went to the open door to the adjoining bathroom. As she started the water in the tub, she peered through a large casement window, searching for landmarks that would give her a clue to their location. All she saw was rocks and trees with snow-laden boughs.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Penny hobbled into the bathroom, using Cole’s arm for ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("support. As he guided her through the doorway, he deftly took the revolver from her hand.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey,” she protested.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you need it, I’ll give it back.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hoping to distract her, Rachel pointed to the swirling water. “Do you need help getting undressed?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Penny glared at both of them. “Get out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before she left, Rachel instructed, “Leave the door unlocked so we can respond if you need help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With Penny disarmed and bathing, Rachel turned to Cole. “I need fresh bedding and something comfortable for her to wear. It’d be nice to have some soft music.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“None of these procedures are medical,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She leaned toward him and lowered her voice so Penny couldn’t hear from the bathroom. “If I’d come in here and wrenched her knees apart for a vaginal exam, she would’ve blown my head off.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He blinked. His eyes were the only part of his face visible. “I guess you know what you’re doing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In the back of my van, there are three cases and an oxygen tank. Bring all the equipment in here.” She stripped the sheets off the bed. “And you can start boiling water.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hot water? Like in the frontier movies?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s for tea,” she said. “Raspberry leaf tea.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Instead of leaving her alone in the bedroom, he opened the door and barked orders. She tried to see beyond him, to figure out how many others were in the house. Not that it mattered. Even if Rachel could escape, she wouldn’t leave Penny until she knew mother and baby were safe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She went to the bathroom and opened the door a crack. “Penny, are you all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grudgingly, she said, “The water feels good.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Some women choose to give birth in the tub.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("“Naked? Forget it.” Her tone had shifted from maniacal ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("to something resembling cooperation. “Is there something else I should do? Some kind of exercise?”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her change in attitude boded well. A woman in labor needed to be able to trust the people around her. Giving birth wasn’t a battle; it was a process.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Relax,” Rachel said. “Take your time. Wash your hair.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the bedroom, Cole thrust the fresh sheets toward her. “Here you go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Would you help me make the bed?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He went to the opposite side and unfolded the fitted bottom sheet of soft lavender cotton. He’d taken off his jacket and was wearing an untucked flannel shirt over a long-sleeved white thermal undershirt and jeans with splotches of blood on the thigh.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pulled the sheet toward her side of the bed. “We’re probably going to be here for hours. You might as well take off that stupid mask.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He straightened to his full height—a couple of inches over six feet—and stared for a moment before he peeled off the black knit mask and ran his fingers through his shaggy, brown hair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Some women would have considered him handsome with his high cheekbones, firm chin and deep-set eyes of cognac brown. His jaw was rough with stubble that looked almost fashionable, and his smile was dazzling. “You’re staring, Rachel. Memorizing my face?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t need to,” she shot back. “I’m sure there are plenty of pictures of you on ‘Wanted’ posters.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I said it before, and I’ll say it again. I’m not going to hurt you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Apart from kidnapping me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I won’t apologize for that. Penny needs you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Rather than answering her challenge, he had appealed ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("to her better instincts. Cole was smooth, all right. Probably a con man as well as a robber. Unfortunately, she had a bad habit of falling for dangerous men. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Not this time.")])])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t bother being charming,” she said. “I’m going to need your help with Penny, but I don’t like you, Cole. I don’t trust a single word that comes out of your mouth.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He grinned. “You think I’m charming.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jerk!")]), _vm._v(" As she smoothed the sheets, she asked, “Which one of the men out there is the father of Penny’s baby?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“None of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Of course not. That would be too easy.")]), _vm._v(" “Can he be reached?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re not on vacation here. This is a hideout. We don’t need to invite visitors.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But this was a nice house—not a shack in the woods. Finding this supposed “hideout” that happened to be conveniently vacant was too much of a coincidence. “You must have planned to come here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hell, no. We were supposed to be in Salt Lake City by now. When Penny went into labor, we had to stop. The house belongs to someone she knows.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The fact that Penny had contacts in this area might come in handy. Rachel needed to keep her ears and eyes open, to gather every bit of information that she could. There was no telling what might be useful.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By the time Penny got out of the tub, Rachel had transformed the bedroom into a clean, inviting space using supplies from her van. The bedding was fresh. A healing fragrance of eucalyptus and pine wafted from an herbal scent diffuser. Native American flute music rose from a CD player.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Before Penny got into bed, Rachel replaced the dressings on her leg wound, using an antiseptic salve to ease the pain. In her work as a nurse-midwife, she leavened ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("various herbal and homeopathic methods with standard medical procedure. Basically, she did whatever worked.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Though Penny remained diffident, she looked young and vulnerable with the makeup washed off her face. Mostly, she seemed tired. The stress of labor and the trauma of being shot had taken their toll.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel took her blood pressure, and she wasn’t surprised that it was low. Penny’s pulse was jumpy and weak.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When her next contraction hit, Rachel talked her through it. “You don’t have to tough it out. If you need the release of yelling—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” she snapped. “I’m not giving those bastards the satisfaction of hearing me scream.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Apparently, she was making up for her weakened physical condition with a powerful hostility. Rachel asked, “Should I send Cole out of the room while I do the vaginal exam?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was quick to leave. “I’ll fetch the tea.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alone with Penny, Rachel checked the cervix. Dilation was already at seven centimeters. This baby could be coming sooner than she’d thought. “You’re doing a good job,” she encouraged. “It won’t be too much longer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is my baby okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let’s check it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Usually, there was an implied trust between midwife and mom, but this situation was anything but usual. As Rachel hooked up the fetal monitor, she tried to be conversational. “When is your due date?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Two days from now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s good. You carried to full term.” At least, there shouldn’t be the problems associated with premature birth. “Is there anything I ought to know about? Any special problems during your pregnancy?”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I got fat.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel did a double take before she realized Penny was joking. “Are you from around here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We lived in Grand Lake for a while. I went to high school in Granby.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s where I live,” Rachel said. “Is your family still in Grand Lake?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s just me and my mom. My dad left when I was little. I never missed having him around.” She touched her necklace and rubbed her thumb over the shiny black pearl. “Mom gave me this. It’s her namesake—Pearl. She lives in Denver, but she’s house-sitting for a friend in Grand Lake.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They weren’t too far from there. Grand Lake was a small village—not much more than a main street of shops and lodging for tourists visiting the scenic lakeside. “Should I try to contact your mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh. My. God.” Penny rolled her eyes. “If my mom knew what I was up to, she’d kill me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her jaw clenched, and Rachel talked her through the contraction. Penny must have had some Lamaze training because she knew the breathing techniques for dealing with the pain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she settled back against the pillows, she said, “If anything happens to me, I want my mom to have my baby.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not the father?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mom’s better.” She chewed her lower lip. “She’ll be a good grandma if I’m not around.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Considering a premature death wasn’t the best way to go into labor. Rachel preferred to keep the mood upbeat and positive. “You’re doing fine. Nothing bad is going to happen.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you believe in premonitions? Like stuff with tarot cards and crystal balls?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not really.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My friend Jenna did a reading for me. Hey, maybe you know her. She lives in Granby, too. Jenna Cambridge?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The name isn’t familiar.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s kind of quiet. Doesn’t go out much,” Penny said. “Every time I visit her, I try to fix her up. But she’s stuck on some guy who dumped her a long time ago. What a waste! Everybody falls. The trick is to get back on the bicycle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Though Rachel wasn’t prone to taking advice from a pregnant criminal who didn’t trust the father of her baby, she had to admit that Penny made a good point. “Doesn’t do any good to sit around feeling down on yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Exactly.” She threw up her hands. “Anyway, Jenna read my cards and told me that something bad was going to happen. My old life would be torn asunder. Those were her words. And she drew the death card.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her friend Jenna sounded like a real peach. Pregnant women were stressed enough without dire warnings. “The death card could mean a change in your life. Like becoming a mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe you’re right. I have changed. I took real good care of myself all through the pregnancy. No booze. No cigs. I did everything right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Except robbing a casino.")]), _vm._v(" Rachel finished hooking up the monitor and read the electronic blips. “Your baby’s heartbeat is strong and steady.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("When Cole returned with the raspberry tea, Rachel moved into the familiar pattern of labor—a combination of her own expertise and the mother’s natural instincts. Needing to move, Penny got out of the bed a couple of times and paced. When she complained of back pain, Cole volunteered to massage. His strong hands provided Penny ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("with relief. He was turning out to be an excellent helper—uncomplaining and quick to follow her instructions.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When the urge to push came, Penny screamed for the first time. And she let go with a string of curses. Though Rachel had pretty much heard it all, she was surprised by the depth and variety of profanity from such a tiny woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cole looked panicked. “Is this normal?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The pushing? Or the I-hate-men tirade?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Both.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Very typical. I bet you’re glad you took the gun away.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hell, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A mere two hours after Rachel had arrived at the house, Penny gave birth to an average-sized baby girl with a healthy set of lungs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Though Rachel had participated in well over two hundred births, this moment never failed to amaze her. The emergence of new life gave meaning to all existence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Postpartum was also a time that required special attention on the part of the midwife. Penny was leaking blood onto the rubber sheet they’d spread across the bed. Hemorrhage was always a danger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel held the newborn toward Cole. “Take the baby. I need to deal with Penny.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dumbstruck, he held the wriggling infant close to his chest. His gaze met hers. In his eyes, she saw a reflection of her own wonderment, and she appreciated his honest reverence for the miracle of life. For a tough guy, he was sensitive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her focus right now was on the mother. Rachel urged, “You need to push again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No way.” With a sob, Penny covered her eyes with her forearm. “I can’t.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had to expel the afterbirth. As Rachel massaged the uterus, she felt the muscles contract, naturally doing what was necessary. The placenta slipped out. Gradually, the bleeding slowed and stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cole stood behind her shoulder, watching with concern. “Is she going to be okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They both are.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Penny forced herself into a sitting position with pillows behind her back. “I want my baby.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With Cole’s help, Rachel clipped the cord, washed the infant and cleared her nose of mucus. The rest of the cleanup could wait. She settled the new baby on Penny’s breast.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As mother and child cooed to each other, she turned toward Cole in time to see him swipe away a tear. Turning away, he said, “I’ll tell the others.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Whoa, there. You’re not leaving me with all the mess to clean up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll be right back.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel sank into a chair beside the bed and watched the bonding of mother and child. Though Penny hadn’t seemed the least bit maternal, her expression was serene and gentle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you have a name?” Rachel asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Goldie. She’s my golden child.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From the other room, she heard the men arguing loudly. Catching bits of their conversation, Rachel got the idea that they were tired of waiting around. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bad news for her.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When the gang was on the run again, they had no further need for a midwife. She was afraid to think of what might happen next.")])])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page25"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e5f3d77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426879708_ch02.vue
// module id = 81
// module chunks = 0